import { render, staticRenderFns } from "./VocabularyMemoForm.vue?vue&type=template&id=5371d29c&scoped=true&lang=pug&"
import script from "./VocabularyMemoForm.vue?vue&type=script&lang=js&"
export * from "./VocabularyMemoForm.vue?vue&type=script&lang=js&"
import style0 from "./VocabularyMemoForm.vue?vue&type=style&index=0&id=5371d29c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5371d29c",
  null
  
)

export default component.exports